import {find} from 'lodash';
import $ from 'jquery';

export default {
   /* eslint-disable vue/require-default-prop, vue/require-prop-types */
   name: 'CareerCard',
   props: ['career'],
   data: function() {
      return {
         favorite: !!find(
            this.$store.state.favorites.careers,
            career =>
               career.jobRole === this.career.jobRole && career.jobDomain === this.career.jobDomain
         ),
      };
   },
   computed: {
      className: function() {
         return `cat-${this.career.shortDomainName}`;
      },
   },
   beforeDestroy: function() {
      $(this.$refs.tooltip).popover('dispose');
   },
   methods: {
      // At first, I tried to use a computed getter and setter for the favorite
      // property, invoking the following code as the setter, but for whatever
      // reason Vue would not remove the active state of a favorite when clicking
      // it again to deactivate it until you clicked a different item to favorite!
      toggleFavorite: function() {
         this.favorite = !this.favorite;
         if (this.favorite) {
            this.$store.commit('favorites/addCareer', {career: this.career});
         } else {
            this.$store.commit('favorites/removeCareer', {career: this.career});
         }
      },
   },
};



// WEBPACK FOOTER //
// ./src/components/CareerObject.js